import { useState, useRef, useEffect } from "react";
import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handler = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const handleSelect = (name: string, url: string) => {
    setSelected(name);
    setOpen(false);
    window.open(url, "_blank", "noopener");
  };

  return (
    <section className="max-w-3xl mx-auto px-4 md:px-6 -mt-10 relative z-20">
      <div className="bg-background-50 rounded-2xl p-5 md:p-6 shadow-sm border border-background-200/70">
        <label className="block text-sm font-semibold text-foreground-700 mb-3">
          Browse Sugargoo Spreadsheet Categories
        </label>
        <div ref={ref} className="relative">
          <button
            onClick={() => setOpen(!open)}
            className="w-full flex items-center justify-between px-5 py-3.5 rounded-xl border border-background-300 bg-background-50 hover:border-primary-300 transition-colors cursor-pointer text-left"
          >
            <span className={selected ? "text-foreground-900 text-sm font-medium" : "text-foreground-500 text-sm"}>
              {selected || "Select a category to start browsing..."}
            </span>
            <span className={`w-5 h-5 flex items-center justify-center transition-transform duration-200 ${open ? "rotate-180" : ""}`}>
              <i className="ri-arrow-down-s-line text-foreground-400 text-lg"></i>
            </span>
          </button>

          {open && (
            <div className="absolute top-full left-0 right-0 mt-2 bg-background-50 border border-background-200 rounded-xl shadow-lg max-h-72 overflow-y-auto z-30">
              {categories.map((cat) => (
                <button
                  key={cat.name}
                  onClick={() => handleSelect(cat.name, cat.url)}
                  className="w-full flex items-center gap-3 px-5 py-3 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors cursor-pointer text-left"
                >
                  <span className="w-5 h-5 flex items-center justify-center">
                    <i className={`${cat.icon} text-foreground-400 text-base`}></i>
                  </span>
                  {cat.name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}